<template>
  <section class="section full-height">
    <admin-section-header icon="view-grid" title="TOOLS: Subscripciones" />
    <div class="tile is-ancestor full-width is-vertical height-100">
      <div class="tile is-parent is-horizontal">
        <dashboard-banner-tile
          title="Microsoft Office 365"
          subtitle=""
          :ctaText="$t('Acceder')"
          ctaTarget="www.office.com/"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-Microsoft_Office_logos_-2013-2019-.svg.png"
        ></dashboard-banner-tile>
        <dashboard-banner-tile
          title="Adebe Acrobat"
          :ctaText="$t('Acceder')"
          ctaTarget="https://www.adobe.com/acrobat/acrobat-pro.html"
          backgroundImage="https://elitek-s3.s3.amazonaws.com/2023-08-07-Adobe%20Acrobat%20Pro%20DC.jpeg"
        ></dashboard-banner-tile>
      </div>
    </div>
  </section>
</template>

<script>
import AdminSectionHeader from '@/components/admin/dasboard/AdminSectionHeader.vue'
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Tools',
  components: {
    AdminSectionHeader,
    DashboardBannerTile
  },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Partners', 'Tools'],
      title: 'Tools'
    })
  }
}
</script>

<style lang="scss" scoped>
button.is-large {
  width: max-content;
  height: max-content;
}
.button-grid button {
  margin: 10px 10px;
  border-color: var(--rosa-dark-eco);
}
</style>
